module.exports = __webpack_public_path__ + "img/partner_berlin.41bdb5ec.svg";